<app-doc-content>
  <div class="row center-xs">
    <div class="col-xs-12 col-sm-11 col-md-10">
      <header class="home-hero">
        <h1>Documentación Epago</h1>
        <p class="home-lead">
          Conecta tu comercio con pagos seguros: guías por plataforma, ejemplos y referencia OpenAPI en un solo lugar.
        </p>
      </header>

      <section class="hub-grid" aria-label="Accesos rápidos">
        <a *ngFor="let card of hubCards" [routerLink]="card.route" class="hub-card">
          <span class="hub-card-icon-wrap" aria-hidden="true">
            <mat-icon class="hub-card-icon">{{ card.icon }}</mat-icon>
          </span>
          <span class="hub-card-body">
            <span class="hub-card-title">{{ card.title }}</span>
            <span class="hub-card-desc">{{ card.description }}</span>
          </span>
          <mat-icon class="hub-card-chevron" aria-hidden="true">chevron_right</mat-icon>
        </a>
      </section>

      <div class="row home-split">
        <div class="col-xs-12 col-md-6">
          <div class="text-container home-copy">
            <div class="paragraph">
              <h2>Conexión sencilla</h2>
              <div class="text-content">
                Reducimos la fricción de integración para conectar comercios a distintos canales en pocas horas.
              </div>
            </div>
            <div class="paragraph">
              <h2>Pago seguro y flexible</h2>
              <div class="text-content">
                El formulario de pago se genera de forma dinámica, con captura segura de datos de tarjeta.
              </div>
              <div class="text-content">
                Tú decides cómo y dónde mostrar el checkout, manteniendo la experiencia de tu tienda.
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="img-container">
            <img class="img-iphone" src="assets/img/flutter-cards-button.png" alt="Vista del botón de pago web" />
          </div>
        </div>
      </div>
    </div>
  </div>
</app-doc-content>
